import { Badge } from "@/components/ui/badge";

interface TimeIndicatorProps {
  status: 'on-time' | 'delayed' | 'cancelled';
}

const TimeIndicator = ({ status }: TimeIndicatorProps) => {
  const getStatusDisplay = () => {
    switch (status) {
      case 'on-time':
        return {
          text: 'A tiempo',
          className: 'bg-green-100 text-green-800'
        };
      case 'delayed':
        return {
          text: 'Retrasado',
          className: 'bg-yellow-100 text-yellow-800'
        };
      case 'cancelled':
        return {
          text: 'Cancelado',
          className: 'bg-red-100 text-red-800'
        };
      default:
        return {
          text: 'A tiempo',
          className: 'bg-green-100 text-green-800'
        };
    }
  };

  const statusDisplay = getStatusDisplay();

  return (
    <Badge variant="outline" className={`text-xs ${statusDisplay.className}`}>
      {statusDisplay.text}
    </Badge>
  );
};

export default TimeIndicator;